export interface Profile {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  organization_name?: string;
  role_name?: string;
  user_type: 'admin' | 'facility' | 'worker' | 'org_admin' | 'super_admin' | 'organization_staff';
  org_code?: string;
  org_id?: number;
  // Add other profile properties here as needed
}

export interface IPermission {
  have_admin: boolean;
  have_read: boolean;
  have_write: boolean;
  have_edit: boolean;
  have_delete: boolean;
}

export interface IUserPermissions {
  [moduleSlug: string]: IPermission;
}

export interface IFetchUserPermissionsPayload {
  data: {
    modules: IUserPermissions;
  };
  status: boolean;
}

export interface IFetchUserProfilePayload {
  data: Profile;
  status: boolean;
}

export interface IUserState {
  profile: {
    loading: boolean;
    data: Profile | null;
    error: string | null;
  };
  permissions: {
    loading: boolean;
    isLoaded: boolean;
    data: IUserPermissions;
    error: string | null;
  };
}

export const FACILITY_USERTYPE: string = "facility";
export const WORKER_USERTYPE: string = "worker";
export const ORG_USERTYPE: string = "org_admin";
export const ORG_STAFF_USERTYPE: string = "organization_staff";
export const ADMIN_USERTYPE: string = "admin";
export const SUPERADMIN_USERTYPE: string = "super_admin";